export default __webpack_public_path__ + "static/media/cardimage1.a9d2119a.png";